export const CallStatusTabs = {
  ALL_CALL_RECORDS: 'all-calls',
  MISSED_AND_ABANDONED_CALLS: 'missed-and-abandoned-calls',
};
